module.exports = __webpack_public_path__ + "img/img13.e3924e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img13.jpg
// module id = 278
// module chunks = 0